import React from "react";
import ReactDOM from "react-dom";

import ModalWorkflow from "./ModalWorkflow";
import "./AjaxWorkflow";

let content = document.getElementById("react-ajax-workflow");
ReactDOM.render(<React.Suspense fallback="">
	<ModalWorkflow />
</React.Suspense>, content);
